import { render, staticRenderFns } from "./service_demand_report.vue?vue&type=template&id=56aeaafe&"
import script from "./service_demand_report.vue?vue&type=script&lang=js&"
export * from "./service_demand_report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports